import type {
  ReturnsCalculatedSummaryReturnedItem,
  ReturnsUploadDocumentsInfoUploadedDocuments
} from '@itsrever/rever-api'

export interface ItemRequiringPhotos {
  lineItemId: string
  name?: string
  variantName?: string
  imageUrl?: string
  returnReason?: string
  uploadedCount: number
}

export const itemsRequiringPhotos = (
  returnedItems: ReturnsCalculatedSummaryReturnedItem[] = [],
  uploadedDocuments: ReturnsUploadDocumentsInfoUploadedDocuments[] = []
): ItemRequiringPhotos[] =>
  returnedItems.flatMap((item) =>
    item.upload_documents_required && item.rever_id
      ? [
          {
            lineItemId: item.rever_id,
            name: item.name,
            variantName: item.variant_name,
            imageUrl: item.image_url,
            returnReason: item.return_reason,
            uploadedCount: uploadedDocuments.filter(
              (document) => document.line_item_id === item.rever_id
            ).length
          }
        ]
      : []
  )
